import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";

export const getClinicInformation = createAsyncThunk('/getClinicInfo', async (data, { rejectWithValue }) => {

    try {
        const response = await axios.get(ENDPOINTS.CLINIC.CLINIC_INFO)
        return response.data;
    } catch (error) {
        return rejectWithValue(
            error.response?.data ||
            "Something went wrong while fetching the buyer profile."
        );
    }
})

const initialState = {
    data: [],
    isLoading: true,
    error: null,
};

const getClinicInfoSlice = createSlice(
    {
        name: "clinic",
        initialState,
        extraReducers: (builder) => {
            builder.addCase(getClinicInformation.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.isLoading = false;
                state.error = null;
            })
                .addCase(getClinicInformation.pending, (state) => {
                    state.isLoading = true;
                    state.error = null;
                })
                .addCase(getClinicInformation.rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.payload;
                })
        }
    }
)

export default getClinicInfoSlice.reducer;